import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function FaqItem({ item, isOpen, onToggle, index = 0 }) {
  const { t } = useTranslation("landing");
  const { key } = item;
  const contentRef = useRef(null);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{
        delay: index * 0.06,
        duration: 0.55,
        ease: [0.16, 1, 0.3, 1],
      }}
      className={clsx(
        "overflow-hidden rounded-2xl border bg-surface transition-all duration-300",
        isOpen
          ? "border-teal-2 shadow-card"
          : "border-line hover:border-teal-3"
      )}
    >
      {/* Question */}
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${key}`}
        id={`faq-question-${key}`}
        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-start sm:px-7 sm:py-6"
      >
        <span className="text-[15px] font-bold leading-snug text-ink sm:text-[16px]">
          {t(`faq.${key}`)}
        </span>

        <motion.span
          animate={{ rotate: isOpen ? 135 : 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className={clsx(
            "grid h-8 w-8 shrink-0 place-items-center rounded-full transition-colors duration-300",
            isOpen
              ? "bg-teal-soft text-teal dark:bg-teal-2/15 dark:text-teal-3"
              : "bg-surface-2 text-teal-2"
          )}
        >
          <Plus className="h-5 w-5" strokeWidth={2} />
        </motion.span>
      </button>

      {/* Answer */}
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            id={`faq-answer-${key}`}
            role="region"
            aria-labelledby={`faq-question-${key}`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <div
              ref={contentRef}
              className="px-5 pb-6 text-[14.5px] leading-[2] text-ink-soft sm:px-7 sm:pb-7 sm:text-[15px]"
            >
              {t(`faq.a${key.replace("q", "")}`)}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}